import { memo, useEffect } from 'react';
import { Table, Col, Card, CardBody } from 'reactstrap';
import { useGetSOVQuery } from '@components/campaigns/campaignsApi';
import { Spinner } from 'reactstrap';
import PercentageColumn from './columns/PercentageColumn';

const CampaignSOVTable = ({ campaignId, onLoadEnd }) => {
  const { data, isFetching, status } = useGetSOVQuery({ id: campaignId });

  useEffect(() => {
    if (status === 'fulfilled') {
      onLoadEnd && onLoadEnd();
    }
  }, [onLoadEnd, status]);

  if (isFetching) {
    return (
      <div className="d-flex align-items-center my-6">
        <Spinner size="sm" className="mx-1" />
        <p className="mx-1 my-0">Loading table...</p>
      </div>
    );
  }

  if (!data || !data.metrics) {
    return <p className="text-center mt-3">No graph data for the current period</p>;
  }

  const { month_keys, metrics } = data;
  const keyLength = month_keys.length;
  const currentMonth = month_keys[keyLength - 1];
  const previousMonth = month_keys[keyLength - 2];
  const firstMonth = month_keys[0];

  const avgFirstMonth = data.sov_avg_monthwise?.client[firstMonth];
  const avgPrevMonth = data.sov_avg_monthwise?.client[previousMonth];
  const avgCurrMonth = data.sov_avg_monthwise?.client[currentMonth];

  return (
    <Col>
      <Card className="mb-4">
        <CardBody className="p-0 pb-3">
          <Table className="table mb-0">
            <thead className="bg-light">
              <tr>
                <th></th>
                {firstMonth && firstMonth != previousMonth && <th scope="col">{firstMonth}</th>}
                {previousMonth && <th scope="col">{previousMonth}</th>}
                <th scope="col">{currentMonth}</th>
                <th scope="col">M/M</th>
                <th scope="col">% Diff</th>
                <th scope="col">{metrics.client?.yy_average ? 'Y/Y' : 'P/P'}</th>
                <th scope="col">% Diff</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Campaign</strong>
                </td>
                {avgFirstMonth !== 0 && firstMonth && firstMonth != previousMonth && <PercentageColumn value={avgFirstMonth} />}
                {avgFirstMonth === 0 && firstMonth && firstMonth != previousMonth && <td className="text-black">0%</td>}

                {avgPrevMonth !== 0 && previousMonth && <PercentageColumn value={avgPrevMonth} />}
                {avgPrevMonth === 0 && previousMonth && <td className="text-black">0%</td>}

                {avgCurrMonth !== 0 && <PercentageColumn value={avgCurrMonth} />}
                {avgCurrMonth === 0 && <td className="text-black">0%</td>}

                <PercentageColumn value={metrics.client?.mm_average} />
                <PercentageColumn value={metrics.mm_diff} />
                <PercentageColumn value={metrics.client?.yy_average ? metrics.client.yy_average : metrics.client?.pp_average} />
                <PercentageColumn value={metrics.client?.yy_average ? metrics.yy_diff : metrics.pp_diff} />
              </tr>
              <tr>
                <td className="fix-rowspan-text">
                  <strong>Control</strong>
                </td>
                {firstMonth && firstMonth != previousMonth && <PercentageColumn value={data.sov_avg_monthwise?.control[firstMonth]} />}
                {previousMonth && <PercentageColumn value={data.sov_avg_monthwise?.control[previousMonth]} />}
                <PercentageColumn value={data.sov_avg_monthwise?.control[currentMonth]} />

                <PercentageColumn value={metrics.control?.mm_average} />
                <td></td>
                <PercentageColumn value={metrics.control?.yy_average ? metrics.control.yy_average : metrics.control?.pp_average} />
                <td></td>
              </tr>
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </Col>
  );
};

export default memo(CampaignSOVTable);
